import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import isNil from 'lodash/isNil'
import ModalDialog from '@vtex/styleguide/lib/ModalDialog'

import Button from '@vtex/styleguide/lib/Button'
import PaymentItem from '@/checkout-instore-legacy/components/Commons/PaymentItem'
import SectionTitle from '@/checkout-instore-legacy/components/Commons/Elements/SectionTitle'
import { buildChildId } from '@/checkout-instore-legacy/utils/TestUtils'

const PaymentsPaid = ({
  paymentsPaid,
  refundPayment,
  showConfirmationModal,
}) => {
  const [showRefundModal, setShowRefundModal] = useState(false)
  const [currentRefund, setCurrentRefund] = useState(null)

  const handleClick = (refund) => {
    setCurrentRefund(refund)
    if (showConfirmationModal) {
      setShowRefundModal(true)
    } else {
      refundPayment(refund)
    }
  }

  const handleModalClose = () => {
    setShowRefundModal(false)
  }

  const handleModalConfirmationClick = () => {
    refundPayment(currentRefund)
    handleModalClose()
  }

  if (!paymentsPaid || paymentsPaid.length === 0) {
    return null
  }

  const paymentsElements = paymentsPaid.map((paymentPaid) => {
    const value =
      !isNil(paymentPaid.payment) && !isNil(paymentPaid.payment.value)
        ? parseInt(paymentPaid.payment.value, 10)
        : null
    return (
      <li
        key={paymentPaid.payment.paymentId}
        className="w-100 bb b--black-10 pointer hover-bg-light-silver bg-animate"
      >
        <PaymentItem
          id={buildChildId('payments-approved', paymentPaid.payment.paymentId)}
          type="approved"
          paymentName={paymentPaid.payment.paymentSystemName}
          groupName={paymentPaid.payment.paymentGroupName}
          onClick={() => handleClick(paymentPaid.refund)}
          value={value}
          installmentsAsOffer={false}
          numberOfInstallments={paymentPaid.payment.installments}
          flexNowrap={false}
        >
          <div className="flex-none self-center ph4 ph5-ns ph6-l ttu">
            <Button size="small" type="submit" variation="primary">
              <FormattedMessage id="refund" />
            </Button>
          </div>
        </PaymentItem>
      </li>
    )
  })

  return (
    <div className="mb5">
      <SectionTitle contentClassName="flex">
        <span className="flex flex-auto ml3-ns mr3-ns">
          <span className="flex-auto">
            <FormattedMessage id="paymentsPaid" />
          </span>
        </span>
      </SectionTitle>
      <ul id="refund-payments-list" className="flex flex-column list ma0 pa0">
        {paymentsElements}
      </ul>
      <ModalDialog
        centered
        loading={false}
        confirmation={{
          onClick: handleModalConfirmationClick,
          testId: 'confirm-refund-modal',
          label: <FormattedMessage id="refundModalConfirmationButton" />,
          isDangerous: true,
        }}
        cancelation={{
          onClick: handleModalClose,
          testId: 'cancel-refund-modal',
          label: <FormattedMessage id="refundModalCancelationButton" />,
        }}
        isOpen={showRefundModal}
        onClose={handleModalClose}
      >
        <div>
          <p className="f3 f3-ns fw3 gray">
            <FormattedMessage id="refundModalTitle" />
          </p>
          <p>
            <FormattedMessage id="refundModalSubtitle" />
          </p>
        </div>
      </ModalDialog>
    </div>
  )
}

PaymentsPaid.propTypes = {
  paymentsPaid: PropTypes.arrayOf(PropTypes.object).isRequired,
  refundPayment: PropTypes.func.isRequired,
  showConfirmationModal: PropTypes.bool,
}

export default PaymentsPaid
